import { toast } from "react-toastify";

import axios, { AxiosError, AxiosInstance } from "axios";

const DEFAULT_HEADERS = {
  "Content-Type": "application/json; charset=utf-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
  "Access-Control-Allow-Headers": "Origin, Content-Type, X-auth-Token",
  timeoutErrorMessage: "timeout",
  timeout: 2000,
};

const errorHandler = (
  error: AxiosError<{ message: string }>
): Promise<never> => {
  toast.error(error?.response?.data?.message);
  return Promise.reject(error);
};

const axiosInstance = (): AxiosInstance => {
  const baseURL = process.env.REACT_APP_BASE_API_URL;

  const instance = axios.create({ baseURL, headers: DEFAULT_HEADERS });

  instance.interceptors.request.use(request => request, errorHandler);
  instance.interceptors.response.use(response => response, errorHandler);
  return instance;
};

export const apiPublicAxios = axiosInstance();

export default { apiPublicAxios };
